import React from 'react';
import { Modal, Box, Typography, Button, List, ListItem, ListItemText } from '@mui/material';
import { useUser } from '../../contexts/UserContext';
import { formatDate } from '../../utils';

interface SelectChildModalProps {
  open: boolean;
  onClose: () => void;
}

const SelectChildModal: React.FC<SelectChildModalProps> = ({ open, onClose }) => {
  const { user, setSelectedChild } = useUser();

  const handleSelectChild = (child: any) => {
    setSelectedChild(child);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
      }}>
        <Typography variant="h6" component="h2" gutterBottom>
          Select a Child
        </Typography>
        <List>
          {user?.children.map((child) => (
            <ListItem key={child.id} disablePadding>
              <ListItemText 
                primary={`${child.fname} ${child.lname}`} 
                secondary={`DOB: ${formatDate(child.dob)}`}
              />
              <Button onClick={() => handleSelectChild(child)}>Select</Button>
            </ListItem>
          ))}
        </List>
      </Box>
    </Modal>
  );
};

export default SelectChildModal;